// 2. Отказы до КП (кол-во ЦО, если Стадия заказа равно Отменено и Сумма заказа равна 0)
export const isValidCancelBKP = (order): boolean => {
    const stage = order["stage-code"]?.toUpperCase();
    return stage === 'ОТМЕНЕНО' && order["contract-sum"] === 0
}